function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M724.6,579.82,827.55,236.61a67.72,67.72,0,0,0-41.16-86.16L773,145.73a67.67,67.67,0,0,0-86.15,41.18L579.31,497.37"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M419.35,514.42,441.78,91.6A67.72,67.72,0,0,1,510.22,25l14.18.19A67.75,67.75,0,0,1,591,93.62L579.31,497.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M287.36,576.09,208.68,159.28a64.75,64.75,0,0,1,52.22-74.9L274.28,82a64.78,64.78,0,0,1,74.92,52.22l70.15,380.21"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M286.75,576,137.12,332.31A52.85,52.85,0,0,0,69,302.17l-10.35,4a52.81,52.81,0,0,0-30.12,68.1l113.94,271L183.41,892l71,205.31"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M449.06,961.1c-3-123.37,153.15-197.92,153.15-197.92l9.52-37.75-128.66-47.7c-33.33-20.8-42.24-61.72-26.57-100.28,12.26-30.22,46.39-22.93,46.39-22.93s193.68,21.27,227.44,37.89c72.49,35.67,44.29,209.74,23.51,264.53s-95.5,222.52-95.5,222.52v39"
})));

function SvgRight4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 856.39 1143.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight4);
export default __webpack_public_path__ + "static/media/right-4.b8d21447.svg";
export { ForwardRef as ReactComponent };